module.exports = __webpack_public_path__ + "img/z128.402e297b.png";